import type { RouteParamsRequest } from '@pba/react-utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type ReadNotificationRouteParams = {
  id: string;
};

export const readNotification = async ({ routeParams: { id } }: RouteParamsRequest<ReadNotificationRouteParams>) =>
  apiClient.post<unknown, ApiClientResponse<unknown>>(routes.notifications.read(id));
